import React from 'react';
import { Box, Typography } from '@mui/material';
import DopamenuBuilder from '../components/DopamenuBuilder';
import PageMetadata from '../components/PageMetadata';
import { toolTextSx } from '../components/ToolCard';

const DESCRIPTION = 'Create your own dopamine menu with activity ideas, colorful printable templates, and rewards to import into a Pomodoro timer. Free, no account needed, saved in your browser.';
const URL = 'https://dopatize.com/tools/dopamenu';
const SCHEMA = { '@context': 'https://schema.org', '@type': 'WebApplication', name: 'Dopatize Dopamine Menu Maker',
  description: DESCRIPTION, url: URL, applicationCategory: 'LifestyleApplication', operatingSystem: 'Any', isAccessibleForFree: true };

export default function DopamenuPage() {
  return (
    <>
      <PageMetadata title="Free Dopamine Menu Maker & Printable | Dopatize" description={DESCRIPTION} url={URL} structuredData={SCHEMA} />
      <Typography component="h1" sx={{ fontSize: { xs: '1.2rem', sm: '1.7rem' }, lineHeight: 1.9, textAlign: 'center', m: 0 }}>Make your dopamenu</Typography>
      <Typography sx={{ ...toolTextSx, textAlign: 'center', mt: 2, mb: 4 }}>Type straight onto your menu. One activity per line.</Typography>
      <DopamenuBuilder />
      <Box component="details" sx={{ mt: 4, ...toolTextSx }}>
        <Box component="summary" sx={{ cursor: 'pointer', color: 'secondary.main' }}>What is a dopamine menu?</Box>
        <Typography sx={{ ...toolTextSx, mt: 2, maxWidth: 800 }}>A dopamine menu, or dopamenu, is a personal list of enjoyable activities. Use starters for quick ideas, mains for longer activities, sides to pair with tasks, desserts for small treats, and specials for plans to look forward to. Choose what works for you. Print your menu or select Save as PDF in your browser’s print dialog. Empty categories leave space to write in your own ideas.</Typography>
      </Box>
    </>
  );
}
